export default "__VITE_ASSET__BD2Ia$Yj__"